import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Quicksand';
  }
  ul,li, ol{
    font-family: 'Quicksand';
    color: ${(props) => props.theme.color.bodyTextColor};

  }
    button {
    all: unset;
    font-family: 'Quicksand';
    font-size: 18px;
    }
    input, select, textarea, option {
      font-family: 'Quicksand';
      font-size: 18px;
    }
    h1,h2,h3,h4{
    /* all: unset; */
    font-family: 'Sansita' ;
    font-style: normal;
    font-weight: 700;
    color: ${(props) => props.theme.color.bodyTextColor};
    
    }
    h1 {
    font-size: 3.5rem;
    line-height: 4.2rem;
    padding: 1rem 0;

    }
    h2 {
    font-size: 3rem;
    line-height: 3.3rem;
    padding: 1rem 0;

    }
    h3 {
    font-size: 2.2rem;
    line-height: 2.6rem;
    padding: 0.5rem 0;

    }
    h4{
    font-size: 1.6rem;
    line-height: 2.4rem;
    padding: 0.5rem 0;

    }
    @media (max-width: 1024px) {
      h1 {
        font-size: 48px;
        line-height: 57px;
      }
      h2 {
        font-size: 32px;
        line-height: 38px;
      }
      h3 {
        font-size: 28px;
        line-height: 33px;
      }
      h4 {
        font-size: 24px;
        line-height: 29px;
      }
    }

    * {
      margin:0;
    }

    svg {
      display: inline;
      fill: currentColor;
}
`;
